// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_pagination__f0I6B {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
}

.Pagination_pagination__page-link__jgV8O {
  display: inline-block;
  width: 2.6rem;
  height: 0.7rem;
  border-radius: 0.3rem;
  background-color: var(--black-22-opacity);
  transition: all 0.3s ease-in-out;
}

.Pagination_pagination__page--active__m09rO .Pagination_pagination__page-link__jgV8O {
  width: 4rem;
  background-color: #000;
}

.Pagination_pagination__break-item-link__jCNo6 {
  width: 2.6rem;
  height: 0.7rem;
  color: var(--black-22-opacity);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--text-xl);
  font-weight: 900;
}
`, "",{"version":3,"sources":["webpack://./src/components/Swiper/Pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".pagination {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 0.5rem;\n}\n\n.pagination__page-link {\n  display: inline-block;\n  width: 2.6rem;\n  height: 0.7rem;\n  border-radius: 0.3rem;\n  background-color: var(--black-22-opacity);\n  transition: all 0.3s ease-in-out;\n}\n\n.pagination__page--active .pagination__page-link {\n  width: 4rem;\n  background-color: #000;\n}\n\n.pagination__break-item-link {\n  width: 2.6rem;\n  height: 0.7rem;\n  color: var(--black-22-opacity);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--text-xl);\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `Pagination_pagination__f0I6B`,
	"pagination__page-link": `Pagination_pagination__page-link__jgV8O`,
	"pagination__page--active": `Pagination_pagination__page--active__m09rO`,
	"pagination__break-item-link": `Pagination_pagination__break-item-link__jCNo6`
};
export default ___CSS_LOADER_EXPORT___;
